/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Swap_Offline_TitleInputs */

const en_us2_workout_swap_offline_title = /** @type {(inputs: Workout_Swap_Offline_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No connection`)
};

const pt_br2_workout_swap_offline_title = /** @type {(inputs: Workout_Swap_Offline_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sem conexão`)
};

const es_419_workout_swap_offline_title = /** @type {(inputs: Workout_Swap_Offline_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin conexión`)
};

const pt_pt2_workout_swap_offline_title = /** @type {(inputs: Workout_Swap_Offline_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sem ligação`)
};

const fr_fr2_workout_swap_offline_title = /** @type {(inputs: Workout_Swap_Offline_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pas de connexion`)
};

const de_de2_workout_swap_offline_title = /** @type {(inputs: Workout_Swap_Offline_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Verbindung`)
};

const it_it2_workout_swap_offline_title = /** @type {(inputs: Workout_Swap_Offline_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessuna connessione`)
};

/**
* | output |
* | --- |
* | "No connection" |
*
* @param {Workout_Swap_Offline_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_swap_offline_title = /** @type {((inputs?: Workout_Swap_Offline_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Swap_Offline_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_swap_offline_title(inputs)
	if (locale === "es-419") return es_419_workout_swap_offline_title(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_swap_offline_title(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_swap_offline_title(inputs)
	if (locale === "de-DE") return de_de2_workout_swap_offline_title(inputs)
	if (locale === "it-IT") return it_it2_workout_swap_offline_title(inputs)
	return en_us2_workout_swap_offline_title(inputs)
});
export { workout_swap_offline_title as "workout-swap.offline_title" }